import BaseModel from '../core/BaseModel'
//import PropertyTypeModel from '@/models/PropertyTypeModel'
export default class OtherCostModel extends BaseModel {

    constructor() {
        super({
                name: "othercost",
                tableName: 'othercost',
                label: "othercost",
                display_key: 'name'
            },
            {
                stt: {
                    name: "stt",
                    label: "No.",
                    type: "Computed",
                    //width: 1,
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                description: {
                    name: "description",
                    label: "Cost",
                    type: "Computed",
                    width: 15,
                    //filter: {type: 'input', match: 'contains'},
                    computed: (data) => {
                        data.cost_name ='' ;
                    },
                },
                //price
                text_amount: {
                    name: "text_amount",
                    label: "Amount",
                    type: "Number",
                    width: 15,
                    class:"small-col-midle  txt-right",
                    computed: (data) => {
                        data.text_amount ='' ;
                    },
                },
            })
    }

}